
import { getDownloadURL, ref } from "firebase/storage";
import { storage } from "../../../backend/firebaseConfig"; // adjust to your config export

const _logoCache = new Map();

async function fetchLogoUrl(brandName) {
  if (!brandName) return "";
  const key = String(brandName).trim();

  if (_logoCache.has(key)) return _logoCache.get(key);

  let url = "";
  for (const extension of ["", "jpg", "png", "jpeg", "svg", "webp", "gif", "avif", "bmp", "JPG", "PNG", "JPEG"]) {
    try {
      url = await getDownloadURL(ref(storage, `Logos/${key}${extension ? `.${extension}` : ""}`));
      break;
    } catch {
      // Try the next supported source format.
    }
  }

  _logoCache.set(key, url);
  return url;
}
const invalidateLogoCache = (brandName) => {
  _logoCache.delete(String(brandName || "").trim());
};

export { fetchLogoUrl, invalidateLogoCache };
